export default __webpack_public_path__ + "static/media/P_Pipoca.59e62bf9.svg";